export const CHAT_MEDIA_TABLE = "chatMedia"
export const CHAT_MEDIA_TABLE_SCHEMA =
  "id, sessionId, messageId, companyId, syncId"
